import ListDocuments from './ListDocuments';

export default ListDocuments;
